import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const UPDATE_REQUEST = 'realhub/publicationTemplatePage/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/publicationTemplatePage/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/publicationTemplatePage/UPDATE_FAILURE'

// Initial State
const initialState = {
  updating: false,
  errors: [],
}

// Actions
export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function bulkUpdateIds(templatePage, publicationIds, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      permissions: publicationIds,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/template_pages/${templatePage.id}/update_publications.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const state = getState()
        const updatedTemplatePage = state.entities.templatePages[templatePage.id] || {}
        const permissionIds = updatedTemplatePage.permission_ids || {}
        permissionIds.publications = json.map(publicationTemplatePage => publicationTemplatePage.publication_id)
        updatedTemplatePage.permission_ids = permissionIds

        const normalizedTemplatePage = normalize(updatedTemplatePage, Schemas.TEMPLATE_PAGE)
        dispatch(updateEntities(normalizedTemplatePage))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
